"use client";

import { useEffect, useState } from "react";
import {
  AuthProviders,
  fetchAuthProviders,
} from "./auth-providers";

type State = {
  providers: AuthProviders | null;
  loading: boolean;
};

/**
 * React hook wrapper around fetchAuthProviders. Uses the module-level cache
 * so multiple components mounting on the same page share a single request.
 *
 * While loading, `providers` is null — render a neutral placeholder rather
 * than assuming any provider is enabled (prevents a flash of the password
 * form on prod).
 */
export function useAuthProviders(): State {
  const [providers, setProviders] = useState<AuthProviders | null>(null);

  useEffect(() => {
    let mounted = true;
    fetchAuthProviders().then((p) => {
      if (mounted) setProviders(p);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return { providers, loading: providers === null };
}
